import LogoutIcon from "@mui/icons-material/Logout";
import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ChooseLanguage from "../../components/base/ChooseLanguage";
import { useAuth } from "../../context/auth";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import { LandingPageTile } from "../LandingPage/LandingPageTile";
import { BackGroundImage } from "../../media/background";
import MyLocationIcon from '@mui/icons-material/MyLocation';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HandshakeIcon from '@mui/icons-material/Handshake';
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";

export const MarketingPanelLandingPage = () => {
    const { logout } = useAuth();
    const { t } = useTranslation();

    const handleLogout = () => {
        logout();
    };

    const { hasAccess } = useAccessControl([USER_ROLES.SALES_MARKETING, USER_ROLES.ADMIN]);

    if (!hasAccess) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                marginTop: -1,
                backgroundImage: `url(${BackGroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPositionX: "right",
                marginBottom: "-40px"
            }}
        >
            {/* AppBar with Logout Button and Language Selector */}
            <AppBar position="static" color="primary">
                <Toolbar sx={{ justifyContent: "flex-end" }}>
                    {/* <ChooseLanguage /> */}
                    <Button
                        color="inherit"
                        sx={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            backgroundColor: "rgba(255,255,255,0.15)",
                            "&:hover": {
                                backgroundColor: "rgba(255, 255, 255, 0.39)",
                            },
                            borderRadius: 2,
                            px: 3,
                        }}
                        onClick={() => (window.location.href = "/")}
                    >
                        {t("page.sales_landing_page.return")}
                    </Button>
                    <Button color="inherit" onClick={handleLogout} startIcon={<LogoutIcon />}>
                        {t("log_out")}
                    </Button>
                </Toolbar>
            </AppBar>
            {/* Main Content */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    flexGrow: 1,
                    padding: 3,
                }}
            >
                <Typography
                    variant="h2"
                    component="h1"
                    align="center"
                    style={{  fontSize:"50px", marginTop: 10 }}
                >
                    {t("page.marketing_panel_landing_page.marketing_panel")}
                </Typography>

                <Grid
                    container
                    justifyContent="center"
                    spacing={1}
                    sx={{
                        // maxWidth: 1500,
                        margin: "0 auto",
                        marginLeft: 0,
                        paddingLeft:0,
                        marginTop:"-75px",
                        marginBottom: 0
                    }}
                >
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.marketing_panel_landing_page.channels")}
                            pageUrl={"/marketing-panel/channels/"}
                            icon={<MyLocationIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.marketing_panel_landing_page.lead_reports")}
                            pageUrl={"/marketing-panel/lead-reports/lead_source/"}
                            icon={<AssessmentIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("headers.contact_channel_report")}
                            pageUrl={"/marketing-panel/contact_channel_report/"}
                            icon={<LocalPhoneIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <LandingPageTile
                            title={t("page.marketing_panel_landing_page.clauses")}
                            pageUrl={"/clauses-admin/"}
                            icon={<HandshakeIcon fontSize="inherit" />}
                            customStyles={{maxWidth: "200px", minWidth: "140px", height: "90px"}}
                            inconFontSize={40}
                        />
                    </Grid>
                    {/* <Grid item>
                        <LandingPageTile
                            title={t("page.marketing_panel_landing_page.settlements")}
                            pageUrl={"/marketing-panel/settlements/"}
                        />
                    </Grid> */}
                </Grid>
            </Box>
        </Box>
    );
};
